export const SAVED_SESSION_KEY = 'skyImpersonationSavedSession';
export const IMPERSONATION_META_KEY = 'skyImpersonationMeta';

export interface ImpersonationMeta {
  targetName: string | null;
  targetEmail: string;
  startedAt: string;
}

export function getImpersonationMeta(): ImpersonationMeta | null {
  try {
    const raw = localStorage.getItem(IMPERSONATION_META_KEY);
    return raw ? (JSON.parse(raw) as ImpersonationMeta) : null;
  } catch {
    return null;
  }
}

export function clearImpersonationRecoveryState(): void {
  localStorage.removeItem(SAVED_SESSION_KEY);
  localStorage.removeItem(IMPERSONATION_META_KEY);
}
